const CalenderFilter = [
  // {
  //   value: 0,
  //   label: "All",
  // },
  {
    value: 1,
    label: "This Week",
  },
  {
    value: 2,
    label: "Last Week",
  },
  {
    value: 3,
    label: "This Month",
  },
  {
    value: 4,
    label: "Last Month",
  },
  {
    value: 5,
    label: "This Quarter",
  },
  {
    value: 6,
    label: "Last Quarter",
  },
  {
    value: 7,
    label: "This 6 Months",
  },
  {
    value: 8,
    label: "Last 6 Months",
  },
  {
    value: 9,
    label: "This Year",
  },
  {
    value: 10,
    label: "Last Year",
  },
  {
    value: 11,
    label: "Custom Date Range",
  },
  {
    value: 12,
    label: "Todays",
  },
];

const servicesList = [
  "Payroll Processing & Compliance",
  "Accounts Payable & Receivable Management",
  "Bank Reconciliation & Cash Flow Management",
  "Budgeting & Forecasting",
  "Income Tax Filing",
  "GST Registration & Filing",
  "Corporate Tax Planning",
  "Tax Deduction & Exemption Advisory",
  "Handling Tax Audits & Notices",
];

const ClientType = [
  { value: 1, label: "One Person Company" },
  { value: 2, label: "Public Limited Company" },
  { value: 3, label: "Limited Liability Partnership" },
  { value: 4, label: "Private Limited Company" },
  { value: 5, label: "Partnership Firm" },
];

const Clients = [
  { value: "Yash Desai", label: "JobMongo Private LTD" },
  { value: "Vishal malhotra", label: "Way Of Worship Private LTD" },
];

const YesNo = [
  { value: 1, label: "Yes" },
  { value: 2, label: "No" },
];
const countryOptions = [
  { value: 1, label: "+1" },
  { value: 2, label: "+44" },
  { value: 3, label: "+91" },
  // Add more countries as needed
];
const models = [
  "FTE/Dedicated Staffing",
  "Adhoc/PAYG/Hourly",
  "Customised Pricing",
];
const Elmodels = [
  { value: 1, label: "FTE/Dedicated Staffing" },
  { value: 2, label: "Adhoc/PAYG/Hourly" },
  { value: 3, label: "Customised Pricing" },
];
const TypeOfJob = [
  { value: 1, label: "GST" },
  { value: 2, label: "Year End" },
];
const DocumentType = [
  { value: 1, label: "Aadhar Card" },
  { value: 2, label: "Voter ID" },
  { value: 3, label: "Pan Card" },
];
const ServiceListDropDown = [
  { value: 1, label: "Payroll Processing & Compliance" },
  { value: 2, label: "Accounts Payable & Receivable Management" },
  { value: 3, label: "Bank Reconciliation & Cash Flow Management" },
  { value: 4, label: "Budgeting & Forecasting" },
  { value: 5, label: "Income Tax Filing" },
  { value: 6, label: "GST Registration & Filing" },
  { value: 7, label: "Corporate Tax Planning" },
  { value: 8, label: "Tax Deduction & Exemption Advisory" },
  { value: 9, label: "Handling Tax Audits & Notices" },
];
const SkillList = [
  { value: 1, label: "Network Security Management" },
  { value: 2, label: "Cloud Infrastructure Management" },
  { value: 3, label: "Software Development & Maintenance" },
];

const frequencyOptions = [
  { value: 1, label: "Monthly" },
  { value: 2, label: "Yearly" },
  { value: 3, label: "One Time" },
  { value: 4, label: "Custom" },
];
const StatusList = [
  { value: 1, label: "WIP in Queries" },
  { value: 2, label: "WIP Job send By JobMongo " },
  { value: 3, label: "WIP Update Queries" },
];
const StatusActiveDeactive = [
  { value: 1, label: "Active" },
  { value: 2, label: "Deactive" },
];

export const AttandaceStatus = [
  { value: 1, label: "Present" },
  { value: 2, label: "Absent" },
];
const DocumentCat = [
  { value: 1, label: "Admin" },
  { value: 2, label: "Other" },
];
const projectOptions = [
  { value: "project_alpha", label: "Project Alpha" },
  { value: "project_beta", label: "Project Beta" },
  { value: "project_gamma", label: "Project Gamma" },
  { value: "project_delta", label: "Project Delta" },
  { value: "project_epsilon", label: "Project Epsilon" },
];

const masterStatusOptions = [
  { value: 1, label: "Pending" },
  { value: 2, label: "Hold" },
  { value: 3, label: "Completed " },
];

const accountmangerOptions = [
  { value: 1, label: "Admin" },
  { value: 2, label: "AccountManager" },
  { value: 3, label: "Reviewer" },
];

export default {
  frequencyOptions,
  masterStatusOptions,
  projectOptions,
  DocumentCat,
  SkillList,
  Elmodels,
  StatusActiveDeactive,
  StatusList,
  YesNo,
  CalenderFilter,
  ServiceListDropDown,
  servicesList,
  ClientType,
  Clients,
  DocumentType,
  countryOptions,
  models,
  TypeOfJob,
  accountmangerOptions,
  AttandaceStatus,
};
